<script lang="ts" setup>
import { defineProps } from 'vue'
import { Badge } from './ui/badge'

const props = defineProps<{
  value?: boolean
  isRedInsteadOfYellow?: boolean
}>()
</script>
<template>
  <Badge
    v-if="props.value"
    :class="{
      'text-yellow-500': !props.isRedInsteadOfYellow,
      'text-red-500': props.isRedInsteadOfYellow,
    }"
    variant="outline"
  >
    Yes
  </Badge>
  <Badge v-else class="text-green-500" variant="outline"> No </Badge>
</template>
